import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-dashboard-tour-modal',
  templateUrl: './dashboard-tour-modal-component.html',
  styleUrls: ['./dashboard-tour-modal-component.scss']
})
export class DashboardTourModalComponent {
constructor(public bsModalRef: BsModalRef) {}
  // parent assigns onClose
  close(action: 'skip'|'start') { this.bsModalRef.hide(); (this as any).onClose?.(action); }
}
